import { mapActions, mapGetters, mapState } from 'vuex';
import { dateToString, toCents } from '@/utils/helpers';
import moment from 'moment';
import ls from '@/helpers/localStorage';
import { MODALS } from '@/components/app/app-modals/app-modals';

const DATE_FORMAT = 'MM/DD/YYYY hh:mm a';

export default {
  props: {
    slim: {
      type: Boolean,
      default: false,
    },
    contract: {
      type: Object,
      required: true,
    },
    items: {
      type: Array,
      required: true,
      default: [],
    },
  },
  data() {
    return {
      showAll: false,
      showAllCut: 5,
    }
  },
  created() {
    this.updateShowAll();
  },
  watch: {
    'contract.contractId': {
      handler() {
        this.updateShowAll();
      },
    },
  },
  computed: {
    ...mapState('trade', ['tradeOptions']),
    ...mapGetters('user', ['isLoggedIn']),
    tableModifiers() {
      return {
        'order-book-sushi__table': true,
        'order-book-sushi__table--slim': this.slim,
      };
    },
    shares() {
      return this.items.map((s) => {
        return {
          ...s,
          pricePerShare: toCents(s.pricePerShare),
          dateExecuted: `${moment(s.dateExecuted).format(DATE_FORMAT)} ET`,
          isNo: (s.predictionType === 0 || s.predictionType === 2),
        };
      });
    },
    showAllItemsNotice() {
      return this.shares.length > this.showAllCut;
    },
    itemsToDisplay() {
      return this.showAll ? this.shares : this.shares.slice(0, this.showAllCut)
    },
  },
  methods: {
    ...mapActions('popup', ['setCurrentSmallPopup', 'setCurrentPopupOptions']),
    getDate(item) {
      const v = dateToString(item.dateExecuted).split(' ');
      return v[0];
    },
    onInfoClick(item) {
      this.setCurrentSmallPopup(MODALS.SMALL_SHARE_INFO);
      this.setCurrentPopupOptions({ item });
    },
    toggleShowAll() {
      this.showAll = !this.showAll;
      ls.set(`order_book_shares_show_all_${this.contract.contractId}`, this.showAll);
    },
    updateShowAll() {
      this.showAll = ls.get(`order_book_shares_show_all_${this.contract.contractId}`, false);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/purchase/sushi/order-book-sushi/order-book-shares-sushi/order-book-shares-sushi.js